import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-view',
  templateUrl: './detalhe-projeto-indicadores-view.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-view.component.scss']
})
export class DetalheProjetoIndicadoresViewComponent extends BaseListComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  indicador: IndicadoresProjeto;
  infoProjeto: ProjetoCadastro;
  modalPrintRef?: BsModalRef;
  infoImprimir?: any = {
    analise: true,
    ponto: true, 
    plano: true,
  };

  @ViewChild('modalPrint') modalPrint: TemplateRef<any>;

  constructor(
    private myService: IndicadoresProjetoService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService,
    private modalService: BsModalService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.indicador = this.activatedRoute.snapshot.data['entity'];
      this.indicador.project = this.infoProjeto;
      this.loaded();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  bloqueioIndicadorProjeto(total: boolean = false) {
    this.loading()
    let obj = {};
    if (total) {
      obj = {
        full_blocked: this.indicador?.full_blocked ? "0" : "1",
      };
    } else {
      obj = {
        meta_blocked: this.indicador?.meta_blocked ? "0" : "1",
      };
    }
    this.addSub(
      this.myService.getBloqueio(this.indicador.id, obj).subscribe({
        next: (res) => {
          if (total) {
            this.indicador.full_blocked = !this.indicador.full_blocked;
          } else {
            this.indicador.meta_blocked = !this.indicador?.meta_blocked;
          }
          this.loaded();
          this.msgSuccess(res?.message);
        },
        error: (err) => {
          this.loaded();
          this.msgError(err.error?.message);
        },
      }),
    )
  }

  editar() {
    return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.indicador?.id, 'editar'];
  }

  voltar() {
    this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores']);
  }

  closePrintModal() {
    this.modalPrintRef?.hide();
  }

  openPrintModal() {
    this.modalPrintRef = this.modalService.show(this.modalPrint);
  }

  async imprimir(){
    this.loading();
    const entidade = await this.authService.getSession();
    const url = `${environment.serverUrl}/rest/relatorios/indicadores/${this.indicador?.id}?entidade_id=${entidade}&analises=${this.infoImprimir?.analise}&pontos=${this.infoImprimir?.ponto}&planos=${this.infoImprimir?.plano}`;
    window.open(url,'_blank');
    this.loaded();
  }
}
